module.exports = __webpack_public_path__ + "static/media/team-5.35f95808.png";